export default {
    attempted: 'Attempted | Attempted',
    pending: 'Pending',
    reached: 'Reached',
};
